import React, { useRef } from 'react';
import { COLUMNS, SEARCH_CONFIG } from '../../InvoiceList.config';
import { useTranslation } from 'react-i18next';
import styles from './InvoicesTable.styles.scss';
import DataTable from '../../../../../../components/shared/DataTable/DataTable';
import { Button } from 'primereact/button';
import { INVOICE_TYPE_LABELS } from '../../../../../../config/invoice/constants';

const InvoicesTable = ({ invoices, getActions, renderStatus, loading }) => {
  const { t, i18n } = useTranslation();
  const tableRef = useRef();

  return (
    <>
      <div className={styles.container}>
        <DataTable
          ref={tableRef}
          tableClassName={styles.table}
          value={invoices}
          loading={loading}
          dataKey="invoiceNumber"
          exportFilename="invoice-list"
          columns={COLUMNS(t, getActions, renderStatus, i18n.language)}
          searchFields={['invoiceNumber']}
          filterDisplay="menu"
          searchConfig={SEARCH_CONFIG}
          showSortInFilters={true}
          exportFunction={({ data, field, rowData, column }) => {
            // Status values need to be translated
            if (field === 'invoiceStatus') {
              return data ? t(`invoice_list.${data}`) : data;
            }

            if (field === 'invoiceTypeEnum') {
              return data
                ? INVOICE_TYPE_LABELS(i18n.language)[rowData.invoiceTypeEnum] ||
                    '-'
                : data;
            }

            // Use the column body renderer when it returns a plain string
            // (covers invoiceType, date columns, solutionSerialNumber, etc.)
            const bodyResult = column?.props?.body?.(rowData);
            if (typeof bodyResult === 'string') {
              return bodyResult;
            }
            return data;
          }}
        />
      </div>
      <div className="d-flex justify-content-end mb-5">
        <Button
          className="text-nowrap bg-white d-flex align-items-center justify-content-center"
          outlined
          style={{
            width: '162px',
          }}
          label={t('export-list')}
          onClick={() => {
            tableRef?.current?.exportCSV();
          }}
        />
      </div>
    </>
  );
};

export default React.memo(InvoicesTable);
